import { render, staticRenderFns } from "./PagesForm.vue?vue&type=template&id=d5a7c336"
import script from "./PagesForm.vue?vue&type=script&lang=js"
export * from "./PagesForm.vue?vue&type=script&lang=js"
import style0 from "./PagesForm.vue?vue&type=style&index=0&id=d5a7c336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports